"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuadTree = exports.BoundsNode = void 0;
var NODE_CORNERS;
(function (NODE_CORNERS) {
    NODE_CORNERS[NODE_CORNERS["TOP_LEFT"] = 0] = "TOP_LEFT";
    NODE_CORNERS[NODE_CORNERS["TOP_RIGHT"] = 1] = "TOP_RIGHT";
    NODE_CORNERS[NODE_CORNERS["BOTTOM_LEFT"] = 2] = "BOTTOM_LEFT";
    NODE_CORNERS[NODE_CORNERS["BOTTOM_RIGHT"] = 3] = "BOTTOM_RIGHT";
})(NODE_CORNERS || (NODE_CORNERS = {}));
/**
 * TODO Got lazy to fully implement to support points without BoundsNode instances inside QuadTree
 * as there might not bee any actual use
 */
var Node = /** @class */ (function () {
    /**
     * @param bounds bounds of the node
     * @param depth current depth of the node
     * @param maxDepth maximum depth of the node
     * @param maxChildren maximum number of children before splitting into subnodes
     */
    function Node(bounds, depth, maxDepth, maxChildren) {
        this.nodes = []; // subnodes reference
        this.children = []; // chilldren contained directly in the node
        this._bounds = { x: 0, y: 0, width: 0, height: 0 };
        this.depth = 0;
        this.maxChildren = 4;
        this.maxDepth = 4;
        this._bounds = bounds;
        this.children = [];
        this.nodes = [];
        this.depth = depth;
        this.maxDepth = maxDepth;
        this.maxChildren = maxChildren;
        this._classConstructor = Node;
    }
    Node.prototype.insert = function (item) {
        if (this.nodes.length) {
            var index = this.findIndex(item);
            this.nodes[index].insert(item);
            return;
        }
        this.children.push(item);
        var len = this.children.length;
        if (!(this.depth >= this.maxDepth) && len > this.maxChildren) {
            this.subdivide();
            for (var i = 0; i < len; i++) {
                this.insert(this.children[i]);
            }
            this.children.length = 0;
        }
    };
    /**
     * Find index of given bounds
     */
    Node.prototype.findIndex = function (item) {
        var _bounds = this._bounds;
        var left = item.x > _bounds.x + _bounds.width / 2 ? false : true;
        var top = item.y > _bounds.y + _bounds.height / 2 ? false : true;
        var index = NODE_CORNERS.TOP_LEFT;
        if (left) {
            // left side
            if (!top) {
                // bottom left
                index = NODE_CORNERS.BOTTOM_LEFT;
            }
            else {
                index = NODE_CORNERS.TOP_LEFT;
            }
        }
        else {
            if (top) {
                // top right
                index = NODE_CORNERS.TOP_RIGHT;
            }
            else {
                // bottom right
                index = NODE_CORNERS.BOTTOM_RIGHT;
            }
        }
        return index;
    };
    Node.prototype.retrieve = function (item) {
        if (this.nodes.length) {
            var index = this.findIndex(item);
            return this.nodes[index].retrieve(item);
        }
        return this.children;
    };
    /**
     * Split node into 4 subnodes inside given bounds
     */
    Node.prototype.subdivide = function () {
        var depth = this.depth + 1;
        var bx = this._bounds.x;
        var by = this._bounds.y;
        var bwh = Math.floor(this._bounds.width / 2);
        var bhh = Math.floor(this._bounds.height / 2);
        var bxbwh = bx + bwh;
        var bybhh = by + bhh;
        // top left
        this.nodes[NODE_CORNERS.TOP_LEFT] = new this._classConstructor({ x: bx, y: by, width: bwh, height: bhh }, depth, this.maxDepth, this.maxChildren);
        // top right
        this.nodes[NODE_CORNERS.TOP_RIGHT] = new this._classConstructor({
            x: bxbwh,
            y: by,
            width: bwh,
            height: bhh
        }, depth, this.maxDepth, this.maxChildren);
        // bottom left
        this.nodes[NODE_CORNERS.BOTTOM_LEFT] = new this._classConstructor({
            x: bx,
            y: bybhh,
            width: bwh,
            height: bhh
        }, depth, this.maxDepth, this.maxChildren);
        // bottom right
        this.nodes[NODE_CORNERS.BOTTOM_RIGHT] = new this._classConstructor({
            x: bxbwh,
            y: bybhh,
            width: bwh,
            height: bhh
        }, depth, this.maxDepth, this.maxChildren);
    };
    Node.prototype.clear = function () {
        this.children.length = 0;
        var len = this.nodes.length;
        for (var i = 0; i < len; i++) {
            this.nodes[i].clear();
        }
        this.nodes.length = 0;
    };
    return Node;
}());
var BoundsNode = /** @class */ (function (_super) {
    __extends(BoundsNode, _super);
    function BoundsNode(bounds, depth, maxDepth, maxChildren) {
        var _this = _super.call(this, bounds, depth, maxDepth, maxChildren) || this;
        _this.stuckChildren = [];
        _this.out = []; // tmp to use as store for performance (not to constantly create new arrays)
        _this.stuckChildren = [];
        _this.out = [];
        _this._classConstructor = BoundsNode;
        return _this;
    }
    /**
     * recursive function to insert to one of the nodes subnodes or cause them to split into further 4 nodes if full
     */
    BoundsNode.prototype.insert = function (item) {
        if (this.nodes.length) {
            var index = this.findIndex(item);
            var node = this.nodes[index];
            // if item is inside the bounds of the BoundsNode, if not the inserted node is stuck
            if (item.x >= node._bounds.x &&
                item.x + item.width <= node._bounds.x + node._bounds.width &&
                item.y >= node._bounds.y &&
                item.y + item.height <= node._bounds.y + node._bounds.height) {
                this.nodes[index].insert(item);
            }
            else {
                this.stuckChildren.push(item);
            }
            return;
        }
        this.children.push(item);
        var len = this.children.length;
        // if depth is at max depth, split the node into four
        if (!(this.depth >= this.maxDepth) && len > this.maxChildren) {
            this.subdivide();
            for (var i = 0; i < len; i++) {
                this.insert(this.children[i]);
            }
            this.children.length = 0;
        }
    };
    /**
     * return array of children and stuck children
     */
    BoundsNode.prototype.getChildren = function () {
        return this.children.concat(this.stuckChildren);
    };
    /**
     * Find given node inside the bounds and return all content that overlaps with them
     */
    BoundsNode.prototype.retrieve = function (item) {
        var out = this.out;
        /** force gbc to clearup the out array. babysitting feature for babbies that cannot into memory management */
        out.length = 0;
        if (this.nodes.length) {
            var index = this.findIndex(item);
            var node = this.nodes[index];
            if (item.x >= node._bounds.x &&
                item.x + item.width <= node._bounds.x + node._bounds.width &&
                item.y >= node._bounds.y &&
                item.y + item.height <= node._bounds.y + node._bounds.height) {
                out.push.apply(out, this.nodes[index].retrieve(item));
            }
            else {
                // bounds are overlapping multiple child nodes, return all containing data for overlapping nodes
                if (item.x <= this.nodes[NODE_CORNERS.TOP_RIGHT]._bounds.x) {
                    if (item.y <= this.nodes[NODE_CORNERS.BOTTOM_LEFT]._bounds.y) {
                        out.push.apply(out, this.nodes[NODE_CORNERS.TOP_LEFT].getAllContent());
                    }
                    if (item.y + item.height >
                        this.nodes[NODE_CORNERS.BOTTOM_LEFT]._bounds.y) {
                        out.push.apply(out, this.nodes[NODE_CORNERS.BOTTOM_LEFT].getAllContent());
                    }
                }
                if (item.x + item.width >
                    this.nodes[NODE_CORNERS.TOP_RIGHT]._bounds.x) {
                    if (item.y <= this.nodes[NODE_CORNERS.BOTTOM_RIGHT]._bounds.y) {
                        out.push.apply(out, this.nodes[NODE_CORNERS.TOP_RIGHT].getAllContent());
                    }
                    if (item.y + item.height >
                        this.nodes[NODE_CORNERS.BOTTOM_RIGHT]._bounds.y) {
                        out.push.apply(out, this.nodes[NODE_CORNERS.BOTTOM_RIGHT].getAllContent());
                    }
                }
            }
        }
        out.push.apply(out, this.stuckChildren);
        out.push.apply(out, this.children);
        return out;
    };
    /**
     * return all contents of the node recursively (ie all the subnodes etc.)
     */
    BoundsNode.prototype.getAllContent = function () {
        var out = this.out;
        if (this.nodes.length) {
            for (var i = 0; i < this.nodes.length; i++) {
                out.push.apply(out, this.nodes[i].getAllContent());
            }
        }
        out.push.apply(out, this.stuckChildren);
        out.push.apply(out, this.children);
        return out;
    };
    /**
     * Free sum mem
     */
    BoundsNode.prototype.clear = function () {
        this.stuckChildren.length = 0;
        this.children.length = 0;
        var len = this.nodes.length;
        if (!len) {
            return;
        }
        // destroy the whole node tree
        for (var i = 0; i < len; i++) {
            this.nodes[i].clear();
        }
        // force destruction of any dangling nodes
        this.nodes.length = 0;
    };
    return BoundsNode;
}(Node));
exports.BoundsNode = BoundsNode;
BoundsNode.prototype._classConstructor = BoundsNode;
var QuadTree = /** @class */ (function () {
    /**
     * @param bounds bounds of the top level of tree
     * @param maxDepth maximum number of levels that tree will have
     * @param maxChildren max number of children that each node can contain before splitting into subnodes
     */
    function QuadTree(bounds, maxDepth, maxChildren) {
        this.root = null;
        this.root = new BoundsNode(bounds, 0, maxDepth, maxChildren);
    }
    /**
     * Inserts an item into tree
     * @param items array of items to insert into quadtree
     */
    QuadTree.prototype.insert = function (items) {
        var len = items.length;
        for (var i = 0; i < len; i++) {
            this.root && this.root.insert(items[i]);
        }
    };
    /**
     * Clears all the nodess and children of the tree
     */
    QuadTree.prototype.clear = function () {
        this.root && this.root.clear();
    };
    /**
     * Retrieves all items / points in the same node as specified item,
     * if the item overlaps the bounds of a node, then all children in both nodes will be returned
     * @param item node
     */
    QuadTree.prototype.retrieve = function (item) {
        return this.root ? this.root.retrieve(item).slice(0) : [];
    };
    return QuadTree;
}());
exports.QuadTree = QuadTree;
